import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { map } from 'rxjs/operators';
import { AppBootSplashService } from '@core/boot/app-boot-splash.service';
import { readLastPublicStoreSlug } from '@features/product-catalog/utils/catalog-last-store-slug.storage';
import { resolvePublicNotFoundHomeCommands } from '@features/product-catalog/utils/public-not-found-home.util';
import { MaterialModule } from 'src/app/material.module';

@Component({
  selector: 'app-public-not-found-page',
  standalone: true,
  imports: [RouterModule, TranslateModule, MaterialModule],
  templateUrl: './public-not-found-page.component.html',
  styleUrls: ['./public-not-found-page.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PublicNotFoundPageComponent {
  private readonly route = inject(ActivatedRoute);
  private readonly bootSplash = inject(AppBootSplashService);

  private readonly fromPath = toSignal(
    this.route.queryParamMap.pipe(map((params) => params.get('from'))),
    { initialValue: this.route.snapshot.queryParamMap.get('from') },
  );

  readonly homeCommands = computed(() =>
    resolvePublicNotFoundHomeCommands(this.fromPath(), readLastPublicStoreSlug()),
  );

  constructor() {
    // Cold load `/{slug}/...` invalida → redirect aquí: el splash quedó en hold.
    this.bootSplash.release();
  }
}
